<template lang="pug">
.basketLeaveModalComponent
  .title У вас осталась незавершенная покупка.<br>Продолжить оформление?
  .buttons
    .link(@click="onConfirmButtonClick") Нет, выйти
    ui-button(
      color="blue-lecta"
      @click="onCancelButtonClick"
    ) Продолжить оформление
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      default: null
    }
  },
  emits: ['close', 'confirm'],
  setup (props, { emit }) {
    const onCancelButtonClick = () => emit('close')
    const onConfirmButtonClick = () => {
      emit('confirm', props.to)
      emit('close')
    }
    return { onConfirmButtonClick, onCancelButtonClick }
  }
}
</script>

<style lang="sass" scoped>
.basketLeaveModalComponent
  margin: 3*$u 25*$u
  display: flex
  flex-flow: column
  gap: 9*$u
  @media (max-width: $MWidth)
    margin: 3*$u 10*$u
  @media (max-width: $XXSWidth)
    margin: 3*$u 0 0 0

  > .title
    text-align: center
    font-size: 20px
    line-height: 6*$u
    font-family: GolosTextWebMedium
  > .buttons
    margin: 0 3*$u
    display: flex
    justify-content: space-between
    gap: 5*$u
    align-items: center
    @media (max-width: $XXSWidth)
      flex-direction: column
  .link
    white-space: nowrap
    cursor: pointer
    border: 1px solid #1A89F9
    border-radius: 10px
    color: #1A89F9
    padding: 2*$u 7.5*$u
    display: flex
    justify-content: center
    align-items: center
    @include font('t16-regular')
</style>
